module.exports = __webpack_public_path__ + "img/code.2b3e8d44.jpg";